import { useMatch } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { paymentRecordQuery } from "@/app/Payments/GraphQL/paymentRecordQuery";

export function usePaymentRecord() {
  const match = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/payments/$id",
  });

  const { data } = useSuspenseGqlQuery(paymentRecordQuery, {
    id: match.params.id,
  });

  return data.payment;
}
